import { Component } from 'react';
import BootstrapAccordion from 'react-bootstrap/Accordion';
import { css } from '@emotion/react';

import Header from '../atoms/Header';
import chevronarrow from '../../../assets/chevron-arrow.png';
import * as InternalPropTypes from '../../../constants/internal-types';
import {
  TypeSEOWeightTypes,
  BackgroundColorEnum,
} from '../../../constants/cms-constants';
import { getSEOWeight } from '../../../utils/SEOWeight';
import SEOWeights from '../../../constants/cms/control-options/seo-weights';

const useStyles = css({
  '.img-container': {
    marginLeft: 'auto',
    marginTop: 'auto',
    marginBottom: 'auto',
  },
  '& .accordion-indicator': {
    transform: 'rotate(90deg)',
    float: 'right',
    willChange: 'transform',
    transition: 'transform 200ms linear',
  },
  '& .Down': {
    transform: 'rotate(-90deg)',
  },
  '& .Up': {
    transform: 'rotate(90deg)',
  },
  '& .indicator': {
    WebkitTransform: 'rotate(180deg)',
    transform: 'rotate(180deg)',
    WebkitBackfaceVisibility: 'hidden',
  },
  '& .accordion-button::after': {
    display: 'none',
  },
  '& .accordion-button:focus': {
    boxShadow: 'none',
  },
  '& .accordion-button': {
    backgroundColor: BackgroundColorEnum.LIGHTGRAY,
    userSelect: 'none',
    borderBottom: `0.5px solid ${BackgroundColorEnum.BRIGHTGRAY}`,
    paddingTop: '12px',
    paddingBottom: '12px',
    marginBottom: '-1px',
  },
  '& .accordion-body': {
    paddingTop: '20px',
    paddingBottom: '20px',
  },
});

type AccordionProps = {
  header?: InternalPropTypes.RichText;
  children?: React.ReactNode;
  seoWeight?: TypeSEOWeightTypes;
};

interface IAccordionState {
  isOpen: boolean;
}

class Accordion extends Component<AccordionProps, IAccordionState> {
  static defaultProps = {
    header: 'Header',
    children: null,
    seoWeight: SEOWeights.H2,
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  handleToggle = () => {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  };

  render() {
    const { header, children, seoWeight } = this.props;
    const { isOpen } = this.state;
    const addSEOWeight = getSEOWeight(seoWeight, seoWeight);
    return (
      <BootstrapAccordion css={useStyles}>
        <BootstrapAccordion.Item eventKey="eventKey">
          <BootstrapAccordion.Header
            onClick={this.handleToggle}
            className="accordion-toggle"
          >
            <Header type={Header.types.TEXTBOXH2} seoWeight={addSEOWeight}>
              {header}
            </Header>
            <div className="img-container">
              <img
                src={chevronarrow}
                alt="Arrow indicating whether accordion is open or not"
                width="18"
                height="18"
                className={`accordion-indicator${isOpen ? ' Down' : ' Up'}`}
              />
            </div>
          </BootstrapAccordion.Header>
          <BootstrapAccordion.Body>{children}</BootstrapAccordion.Body>
        </BootstrapAccordion.Item>
      </BootstrapAccordion>
    );
  }
}

export default Accordion;
